import React from "react";
import "./style.css";
import { Link } from "react-router-dom";

import { IoLogoFacebook, IoLogoGithub, IoLogoBehance, IoLogoLinkedin } from "react-icons/io5";
import { FaIdCard } from "react-icons/fa";
import { HiArrowNarrowRight, HiMail, HiPhone } from "react-icons/hi";
import { MdNearMe } from "react-icons/md";

import Banner from "../../components/Widgets/Banner";

const Contact = () => {
    return (
        <div className="contact">
            <Banner route="contact us">
                <div className="socials">
                    <Link to="#"><IoLogoFacebook className="contact-link" /></Link>
                    <Link to="#"><IoLogoGithub className="contact-link" /></Link>
                    <Link to="#"><IoLogoBehance className="contact-link" /></Link>
                    <Link to="#"><IoLogoLinkedin className="contact-link" /></Link>
                </div>
            </Banner>
            <ContactForm />
        </div>
    )
}


const ContactForm = () => {
    return (
        <div className="contact-form">
            <div >
                <h3 className="contact-form-header"><FaIdCard />  <span>Get In Touch</span></h3>
            </div>
            <div className="our-info-wrapper">
                <div className="form-component">
                    <form >
                        <ContactInput text="Your Name" type="text" />
                        <ContactInput text="Email Address" type="text" />
                        <ContactInput text="Message" />
                        <ContactButton />
                    </form>
                </div>
                <div className="our-info">
                    <p><HiMail className="info-icon" /><span>devvyhac@gmail.com</span></p>
                    <p><HiPhone className="info-icon" /><span>+234 8069833426, +234 9034726175</span></p>
                    <p><MdNearMe className="info-icon" /><span>Asadam Ilorin, Nigeria</span></p>
                </div>
            </div>
        </div>
    )
}

const ContactInput = ({ text, type="text" }) => {
    return (
        <div>
            {
            type ? 
                <input type="text" className="contact-input" placeholder={ text } /> : 
                <textarea rows={5} className="contact-input" placeholder={ text }></textarea>
            }
        </div>
    )
}

const ContactButton = () => {
    return (
        <div>
            <Link to="#" className="contact-button">
                <span>Send Now</span> <HiArrowNarrowRight />
            </Link>
        </div>
    )
}

export default Contact;